export default "__VITE_ASSET__BGI9hG7n__"